import { render } from "./ListeArticlePage.vue?vue&type=template&id=7008d9e4&ts=true"
import script from "./ListeArticlePage.vue?vue&type=script&lang=ts"
export * from "./ListeArticlePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__